import * as React from 'react';
import { compose } from 'redux';

import { Button } from '@acceligentllc/storybook';

import type { AdditionalFilterType } from '..';
import type { CredentialFilter, CredentialFilterOption } from './CredentialsFilter';
import CredentialsFilter from './CredentialsFilter';
import styles from './styles.module.scss';

interface OwnProps {
	changeCredentialFilters: (options: CredentialFilterOption, organizationCredentialId: number) => void;
	selectedCredentialFilter: Nullable<CredentialFilter>;
	activeAdditionalFilters: Nullable<AdditionalFilterType>;
	resetAdditionalFilters: () => void;
	autoOpenFilters: boolean;
	clearCredentialsFilter: (id: number) => void;
}

type Props = OwnProps;

const EmployeeTableAdditionalFilters: React.FC<Props> = (props) => {
	const {
		activeAdditionalFilters,
		changeCredentialFilters,
		resetAdditionalFilters,
		autoOpenFilters,
		clearCredentialsFilter,
		selectedCredentialFilter,
	} = props;

	const renderFilter = React.useCallback((option: AdditionalFilterType) => {
		return (
			<CredentialsFilter
				autoOpen={autoOpenFilters}
				key={option.id}
				label={option.label}
				onChange={changeCredentialFilters}
				onClear={clearCredentialsFilter}
				organizationCredentialId={+option.id}
				selected={selectedCredentialFilter?.field ?? null}
			/>
		);
	}, [autoOpenFilters, changeCredentialFilters, clearCredentialsFilter, selectedCredentialFilter]);

	return (
		<>
			{activeAdditionalFilters && renderFilter(activeAdditionalFilters)}
			{
				!!activeAdditionalFilters &&
				<Button customStyleClass={styles.resetButton} label="Reset" onClick={resetAdditionalFilters} style="link" />
			}
		</>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo
);

export default enhance(EmployeeTableAdditionalFilters);
